import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { LinkSection } from '../../types/link';
import { PlainImageSection, imageToPicture } from '../../../app/components/plain-image/plain-image.component';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type ButtonOnImageSection = Section<
  {
    numColumns: 8 | 12;
    icon: 'location' | 'mail' | 'phone';
    medium: PlainImageSection;
    button: LinkSection;
    headline?: string;
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'medium',
    'button',
  ],
  'button-on-image'
>;

@Component({
  selector: 'app-button-on-image',
  styleUrls: ['./button-on-image.component.scss'],
  templateUrl: './button-on-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    OgImageDirective,
    OverlayFigureComponent,
    PictureComponent,
    FsButtonComponent,
],
})
export class ButtonOnImageComponent extends SectionComponent<ButtonOnImageSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Ultrawide;
  protected variants = [{
    aspectRatio: this.aspectRatio,
  }];

}
